import { SDKProvider, useLaunchParams } from '@tma.js/sdk-react';
// import { type FC, useEffect, useMemo } from 'react';

import { App } from '../App';
import { LanguageProvider } from '../LanguageProvider';

// const ErrorBoundaryError: FC<{ error: unknown }> = ({ error }) => (
//   <div>
//     <p>An unhandled error occurred:</p>
//     <blockquote>
//       <code>
//         {error instanceof Error
//           ? error.message
//           : typeof error === 'string'
//           ? error
//           : JSON.stringify(error)}
//       </code>
//     </blockquote>
//   </div>
// );

const Inner = () => {
  // const debug = useLaunchParams().startParam === 'debug';
  // const manifestUrl = useMemo(() => {
  //   return new URL('tonconnect-manifest.json', window.location.href).toString();
  // }, []);

  return (
    <SDKProvider acceptCustomStyles>
      <LanguageProvider>
        {' '}
        <App />{' '}
      </LanguageProvider>
    </SDKProvider>
  );
};

export const Root = () => (
  <>
    <Inner />
  </>
);
